import axios from "axios";
import dayjs from "dayjs";

// POS module: business date, POS bills / returns, shift close per counter,
// day close and the POS reports (API PosController, DB script section 29).
// Errors come back as { Message }: 400 for a broken rule, 409 for a state
// clash (a closed day, open shifts, a bill in a closed shift).
const base_path = window.APP_CONFIG?.BASE_URL;
const P = `${base_path}/Api/Pos`;

/** The till's own date; the server starts the business date from it the first time. */
export const tillToday = () => dayjs().format("YYYY-MM-DD");

/** { transactionDate, lastDayClose, counters: [{counterID, counterName, shiftNo, ...totals}], closedShifts } */
export const getPosState = async (globalBranchID) => {
  const response = await axios.get(`${P}/GetState?globalBranchID=${globalBranchID}&today=${tillToday()}`);
  return response.data;
};

/**
 * Saves a POS bill (salesTransType 2) or return (3). The server numbers it
 * (POS… / POSR…), dates it on the business date and files it under the
 * counter's open shift. Resolves to { guid, entryNumber, transactionDate, shiftNo }.
 */
export const savePosBill = async (bill) => {
  const response = await axios.post(`${P}/SaveBill?today=${tillToday()}`, JSON.stringify(bill));
  return response.data;
};

// { branchID, counterID, countedCash, remarks, userID }
export const closePosShift = async (data) => {
  const response = await axios.post(`${P}/CloseShift`, JSON.stringify({ ...data, today: tillToday() }));
  return response.data;
};

// { branchID, remarks, userID }
export const closePosDay = async (data) => {
  const response = await axios.post(`${P}/CloseDay`, JSON.stringify({ ...data, today: tillToday() }));
  return response.data;
};

/** POS bills and returns by transaction date (yyyy-MM-dd, inclusive), with their lines. */
export const getPosBills = async (globalBranchID, fromDate, toDate) => {
  const response = await axios.get(
    `${P}/GetBills?globalBranchID=${globalBranchID}&fromDate=${fromDate}&toDate=${toDate}`
  );
  return response.data;
};

export const getPosBillByNumber = async (globalBranchID, entryNumber) => {
  const response = await axios.get(
    `${P}/GetBillByNumber?globalBranchID=${globalBranchID}&entryNumber=${encodeURIComponent(entryNumber)}`
  );
  return response.data;
};

export const getPosShiftCloses = async (globalBranchID, fromDate, toDate) => {
  const response = await axios.get(
    `${P}/GetShiftCloses?globalBranchID=${globalBranchID}&fromDate=${fromDate}&toDate=${toDate}`
  );
  return response.data;
};

export const getPosDayCloses = async (globalBranchID, fromDate, toDate) => {
  const response = await axios.get(
    `${P}/GetDayCloses?globalBranchID=${globalBranchID}&fromDate=${fromDate}&toDate=${toDate}`
  );
  return response.data;
};

/** The message an API error carries, or the fallback. */
export const posError = (error, fallback) =>
  error?.response?.data?.Message || error?.response?.data?.message || fallback;

/* ---------------------------------------------------------------- this till's counter */

// Which counter a till bills on belongs to the device, not to the user, so it
// is kept in the browser, per branch.
const counterKey = (branchGuid) => `pos.counter.${branchGuid}`;

export const readTillCounter = (branchGuid) => {
  try {
    return window.localStorage.getItem(counterKey(branchGuid)) || "";
  } catch {
    return "";
  }
};

export const writeTillCounter = (branchGuid, counterID) => {
  try {
    window.localStorage.setItem(counterKey(branchGuid), counterID || "");
  } catch {
    /* storage blocked: the till asks again next time */
  }
};
